<template>
  <div class="avatarApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <h2>修改头像</h2>
    <el-upload
      class="avatar-uploader"
      :action="baseUrl+'wx/User/upload'"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload">
      <img v-if="avatar" :src="imageUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <div class="btn" @click="update">确定</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        imageUrl: '',
        avatar:''
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getUser();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.avatar = res.data;
      },
      beforeAvatarUpload(file) {
        //const isJPG = file.type === 'image/jpeg';
        //const isLt2M = file.size / 1024 / 1024 < 2;

        //if (!isJPG) {
          //this.$message.error('上传头像图片只能是 JPG 格式!');
        //}
        //if (!isLt2M) {
          //this.$message.error('上传头像图片大小不能超过 2MB!');
        //}
        //return isJPG && isLt2M;
      },
      getUser:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'wx/User/user',
          params:{
            userId:that.userData.id
          }
        }).then(function(response){
          var res = response.data
          that.imageUrl = res.data.avatar
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      update:function(e){
        var that = this;
        if(that.avatar == ''){
          this.$message.error('请上传头像');
          return false;
        }
        that.fullscreenLoading = true;
        this.axios({
          'url': that.$host+'wx/user/editUser',
          'method': 'post',
          params:{
            userId:that.userData.id,
            avatar:that.avatar
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          that.$router.back()
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .avatarApp{
    max-width:640px;
    background:#fff;
    margin:0 auto;
  }
  .avatarApp h2{
    font-size:18px;
    padding:25px;
  }

  .avatar-uploader .el-upload {
    border: 1px solid #d9d9d9;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    left:25px
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 88px;
    height: 88px;
    line-height: 88px;
    text-align: center;
  }
  .avatar {
    width: 88px;
    height: 88px;
    display: block;
  }
  .avatarApp .btn{
    height: 45px;
    background: #007ae6;
    text-align: center;
    line-height: 45px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    border-radius: 6px;
    margin-top: 5px;
    position:fixed;
    bottom:50px;
    width:85%;
    left:7.5%
  }
</style>